import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Inject } from '@angular/core';
// import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
// import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ChangeUsersService } from './services/change-users.service';
import { SideMenuComponent } from './shared/side-menu/side-menu.component';

import { AutoLogoutServiceService } from './services/auto-logout-service.service';
import { BaseUrlConstantsService } from "./services/base-url-constants.service";
import { BackendApiService } from './services/backend-api.service';
import { HttpClient } from '@angular/common/http';
import { HostWatcherComponent } from './host-watcher/host-watcher.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SideMenuComponent, HostWatcherComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',

})
export class AppComponent {
  // public onSideNavChange: boolean;
  public dsp = BaseUrlConstantsService.DSP_KEY;
  token: string = "";
  showModal = false;
  modalMessage = '';
  modalTitle = 'Network Status';
  modalStatus = 'unknown';
  networkDetails: any = {};
  private healthCheckInterval: any;
  private lastStatus: string = 'fully_connected';
  public onPrem = BaseUrlConstantsService.ON_PREM;
  private lastStorageWarning: boolean = false;



  ngOnInit() {
    this.startSessionCheck();
    if (this.onPrem) {
      this.startHealthCheck();
    }

    // --- TEMPORARY MOCK TO VIEW MODAL IN UI ---
    // setTimeout(() => {
    //   const originalOnPrem = this.onPrem;
    //   this.onPrem = true; // Bypass the check temporarily
    //   this.handleNetworkResponse({
    //     status: 'fully_connected',
    //     message: 'System is running normally.',
    //     storage_usage_percentage: 5,
    //     storage_total_gb: 500,
    //     storage_used_gb: 460
    //   });
    //   this.onPrem = originalOnPrem; // Restore
    // }, 2000);
    // ------------------------------------------
  }

  startHealthCheck() {
    this.checkHostWatcher();
    this.healthCheckInterval = setInterval(() => {
      this.checkHostWatcher();
    }, 10000);
  }
  async checkHostWatcher() {
    if (!this.onPrem) {
      return;
    }
    try {
      const response: any = await this.service.getDataV2('http://localhost/dns-check/health');
      // const response: any = await this.service.getDataV2('http://localhost:5001/health');
      this.handleNetworkResponse(response);
    }
    catch (error) {
      console.error('Health check failed: ', error);
      const newStatus = 'service_down';
      if (this.lastStatus !== newStatus) {
        this.modalMessage = 'Unable to connect to the host watcher service. The monitoring system may be offline.';
        this.modalTitle = 'Service Unavailable';
        this.modalStatus = newStatus;
        this.showModal = true;
        this.lastStatus = newStatus; // Update lastStatus to prevent repeated modal
      }
    }
  }

  handleNetworkResponse(response: any) {
    if (!this.onPrem) {
      return;
    }

    const { status, message, container_ip, router_ip_target, timestamp, storage_usage_percentage, storage_total_gb, storage_used_gb } = response;
    const previousStatus = this.lastStatus;

    this.modalStatus = status;
    this.networkDetails = {
      container_ip,
      router_ip_target,
      timestamp: timestamp ? new Date(timestamp).toLocaleString() : 'N/A',
      status,
      storage_usage_percentage,
      storage_total_gb,
      storage_used_gb
    };

    // Check storage status
    const storageWarning = storage_usage_percentage >= 70;
    const storageChanged = storageWarning !== this.lastStorageWarning;

    let storageMessageHtml = '';
    if (storageWarning) {
      storageMessageHtml = `<div style="background-color: ${storage_usage_percentage <= 70 ? 'green' : (storage_usage_percentage > 70 && storage_usage_percentage <= 80) ? 'orange' : 'red'}; color: white; font-size: 40px; padding: 10px; border-radius: 5px;">STORAGE WARNING: <strong>${storage_usage_percentage}%</strong> Used (<strong>${storage_used_gb}GB</strong> / <strong>${storage_total_gb}GB</strong>)<br>${storage_usage_percentage > 80 ? 'Please free up disk space immediately!' : ''}</div><br><br>`;
    }

    // --- Case 1: Fully Connected ---
    if (status === 'fully_connected') {
      // Show modal only if coming from an error state OR storage warning is triggered
      if ((previousStatus && previousStatus !== 'fully_connected') || (storageWarning && storageChanged)) {
        this.modalTitle = storageWarning ? '⚠️ Storage Alert - Network Connected' : 'Network Status - Fully Connected';

        // let storageMessage = '';
        // if (storageWarning) {
        //   storageMessage = `\n\n🔴 STORAGE WARNING: ${storage_usage_percentage}% Used (${storage_used_gb}GB / ${storage_total_gb}GB)\nPlease free up disk space immediately!`;
        // }

        this.modalMessage = `${storageMessageHtml}✅ ${message}`;
        this.showModal = true;

        // Auto-close modal after 4 seconds only if no storage warning
        if (!storageWarning) {
          setTimeout(() => {
            this.closeModal();
          }, 4000);
        }
      } else {
        // Already fully connected and no new storage warning → keep modal closed
        this.closeModal();
      }
    }

    // --- Case 2: No LAN Connected ---
    else if (status === 'no_lan_connected') {
      if (previousStatus !== 'no_lan_connected') {
        // let storageMessage = '';
        // if (storageWarning) {
        //   storageMessage = `\n\n🔴 STORAGE WARNING: ${storage_usage_percentage}% Used (${storage_used_gb}GB / ${storage_total_gb}GB)`;
        // }

        this.modalTitle = 'Network Status - Disconnected';
        this.modalMessage = `${storageMessageHtml}❌ NETWORK WARNING: ${message}<br><br>Please check your network cables and router connection.`;
        this.showModal = true;
      }
    }

    // --- Case 3: Other Errors/Warnings ---
    else {
      if (status !== previousStatus || (storageWarning && storageChanged)) {

        // Prepend storage message to whatever specific message is generated below
        let baseNetworkMessage = '';

        switch (status) {
          case 'no_internet':
            this.modalTitle = 'Network Status - Limited Connection';
            baseNetworkMessage = `⚠️ ${message}<br><br>Local network is functional, but internet access is unavailable.`;
            break;

          case 'unknown':
            this.modalTitle = 'Network Status - Unknown';
            baseNetworkMessage = `❓ ${message}<br><br>Unable to determine network status completely.`;
            break;

          default:
            this.modalTitle = 'Network Status - Unknown State';
            baseNetworkMessage = `${message || 'Unknown network status received.'}`;
        }

        // Combine: Storage First
        this.modalMessage = `${storageMessageHtml}${baseNetworkMessage}`;
        this.showModal = true;
      }
    }

    // Update last status and storage warning flag after processing
    this.lastStatus = status;
    this.lastStorageWarning = storageWarning;
  }


  closeModal() {
    this.showModal = false;
  }

  constructor(private http: HttpClient, private autoLogout: AutoLogoutServiceService, public changeUserDashboard: ChangeUsersService, public router: Router, public service: BackendApiService) {
    // this._sidenavService.sideNavState$.subscribe(res => {
    //   // this.onSideNavChange = res;
    // });

    const hash = window.location.hash;
    const queryString = hash.split('?')[1] || '';  // Get the part after "?"
    const urlParams = new URLSearchParams(queryString);  // Parse the query string
    const monitoringWindow = urlParams.get('Monitoring_window');
    const powertrainWindow = urlParams.get('Powertrain_window');
    // console.log(monitoringWindow, "================================");
    const QRLogin = urlParams.get('QRKey');

    if (localStorage.getItem('loginStatus') === 'yes') {
      console.log("Is logged in");
      if (monitoringWindow === 'true') {
        this.changeUserDashboard.login('Log In');
        powertrainWindow == "true" ? this.router.navigate(['detail-nxt-v2']) : this.router.navigate(['/detail-nxt']);
      } else {
        switch (localStorage.getItem('role')) {
          case 'ADMIN':
            this.changeUserDashboard.login('Log In');
            this.router.navigate(['/admin-dashboard']);
            break;
          case 'CLIENT':
            this.changeUserDashboard.login('Log In');
            this.router.navigate(['/device-reports']);
            break;
          case 'USER':
            this.changeUserDashboard.login('Log In');
            this.router.navigate(['/device-reports']);
            break;
          case 'ACCOUNT_MANAGER':
            this.changeUserDashboard.login('Log In');
            this.router.navigate(['/manager-client-list']);
            break;
        }
      }
    } else if (QRLogin) {
      console.log("QR Login detected");
      this.changeUserDashboard.login('Log In');
      this.router.navigate(['/QRlogin'], { queryParams: { QRKey: QRLogin } });
    }
    else {
      console.log("not logged in");
      this.changeUserDashboard.logout();
    }
  }


  ngOnDestroy(): void {

  }
  startSessionCheck() {
    this.checkSessionValidity(); // Run once on app load

    setInterval(() => {
      this.checkSessionValidity();
    }, 5 * 60 * 1000); // Every 5 minutes
  }

  checkSessionValidity() {
    const storedTimestamp = localStorage.getItem("timestamp");
    const qrLogin = localStorage.getItem("QR-login");

    if (qrLogin && storedTimestamp) {
      const savedTime = parseInt(storedTimestamp, 10);
      const currentTime = Date.now();
      const sixHoursInMs = 1 * 60 * 60 * 1000

      if (currentTime - savedTime > sixHoursInMs) {
        localStorage.clear();
        this.router.navigate(['login']);
        this.changeUserDashboard.logout();
        this.service.showError("Session expired please login again");
      }
    }
  }

}
